// components/Benefits.js — Architecture Section
import React from 'react';
import './Benefits.css';

function Benefits() {
  const pillars = [
    {
      icon: '☁️',
      title: 'S3-Native Storage',
      description: 'Data lives in object storage at $0.023/GB. Postgres reads and writes seamlessly through our custom storage engine — no external ETL needed.',
    },
    {
      icon: '⚡',
      title: 'LSM Write Engine',
      description: 'A log-structured merge-tree under the hood handles millions of vector writes per second, then compacts and flushes to S3 in the background.',
    },
    {
      icon: '🧊',
      title: 'Hot / Warm / Cold Tiering',
      description: 'Recent data on NVMe for sub-millisecond reads. Aging data migrates to S3 — automatically, based on access patterns.',
    },
  ];

  return (
    <section id="architecture" className="architecture">
      <div className="architecture__container">
        <p className="section-eyebrow">How It Works</p>
        <h2>Built for Infinite Scale</h2>
        <p className="section-subtitle">
          A Postgres extension that replaces the default heap storage with an S3-backed LSM engine.
        </p>
        <div className="architecture__grid">
          {pillars.map((pillar, index) => (
            <div key={index} className="architecture__card">
              <div className="architecture__card-icon">{pillar.icon}</div>
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Benefits;